export type LoadingSetter = (loading: boolean) => void

/** Keep the primary AI spinner scoped to the generation operation only. */
export async function withGenerationLoading<T>(
  setLoading: LoadingSetter,
  generationOperation: () => Promise<T>,
): Promise<T> {
  setLoading(true)
  try {
    return await generationOperation()
  } finally {
    setLoading(false)
  }
}

/** Run refreshes independently so one failed/hung refresh cannot block another. */
export function startNonCriticalRefreshes(
  refreshes: Array<{ name: string; run: () => Promise<unknown> }>,
): void {
  refreshes.forEach(({ name, run }) => {
    void run().catch((error) => {
      console.error(`AI assistant ${name} refresh failed:`, error)
    })
  })
}
